import {NgClass}                                     from '@angular/common';
import {AfterViewInit, Component, inject}            from '@angular/core';
import {FormsModule, ReactiveFormsModule}            from '@angular/forms';
import {MoodMatrix, MoodRecordLogIntf, MoodTermType} from '@djsharkk/logr-types';
import {DateTime}                                    from 'luxon';
import {MenuCrudPanelContentBase}                    from '../../menu-crud-panel-content-base';
import {MenuCrudPanelToggleBase} from '../../menu-crud-panel-toggle-base';
import {MenuCrudPanelMoodService}                    from './menu-crud-panel-mood.service';

@Component({
			   selector   : 'app-menu-crud-mood',
			   imports: [
				   ReactiveFormsModule,
				   FormsModule,
				   NgClass
			   ],
			   templateUrl: './menu-crud-panel-mood-top.component.html',
			   styleUrl   : './menu-crud-panel-mood-top.component.css'
		   })
export class MenuCrudPanelMoodTopComponent extends MenuCrudPanelContentBase<MoodRecordLogIntf, undefined> implements AfterViewInit {
	svcMenuCrudMood = inject(MenuCrudPanelMoodService)

	dateInputString: string = '';
	dateInputObject: Date = new Date();


	constructor() {
		super('mood', false);

		// Initialize `filteredMoods` as a reactive stream, starting with an empty array

	}

	public ngAfterViewInit() {

	}





	// updateDate($event: string): void {
	// 	const dtObj = DateTime.fromJSDate(new Date($event));
	// 	this.data.data.timestamp = Timestamp.fromDate(dtObj.toJSDate());
	// 	this.updateDateFormats();
	// }

	updateDateFormats($event: string) {
		const dte = new Date($event)
		this.dateInputString = DateTime.fromJSDate(dte)?.toFormat('yyyy-MM-dd\'T\'HH:mm:ss')
		this.dateInputObject = dte;
	}

	public toggleActiveItem(term: MoodTermType) {
		if (this.svcMenuCrudMood.selected.includes(term)) {
			this.svcMenuCrudMood.selected = this.svcMenuCrudMood.selected.filter(selectedTerm => selectedTerm !== term);
		} else {
			this.svcMenuCrudMood.selected.push(term);
		}
	}

	protected readonly MoodMatrix = MoodMatrix;
}
